import { CameraList } from "components/front/VIDEO/Camera/List/CameraList"
import React from "react"

export const CameraListRoute = () => {
  return <div>
    <CameraList />
  </div>
}